import script from "./workspace-sign-in-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./workspace-sign-in-modal.vue?vue&type=script&setup=true&lang=js"

import "./workspace-sign-in-modal.vue?vue&type=style&index=0&id=31e804b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31e804b4"]])

export default __exports__